/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import ViewCompTrainingPresenter from "./ViewCompTrainingPresenter";
import DTOViewCompletedTraining from "./DTOViewCompletedTraining";
import { trainingServices } from "../../../../api/services/trainingServices";
import { useAppSelector } from "../../../../infra/hooks";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  editTraineesData: any;
}
const ViewCompTrainingController = ({
  isModalOpen,
  closeModal,
  editTraineesData,
}: ModalInterface) => {
  const { t, i18n } = useTranslation();
  const [trainingEva, setTrainingEva] = useState([]);
  const selector = useAppSelector((state) => state.authSlice);

  useEffect(() => {
    async function fetchTrainingEva() {
      const result = await trainingServices.getMarkasCompletedTraining(
        editTraineesData?.trainees[0].training_id
      );
      setTrainingEva(result?.data);
    }
    fetchTrainingEva();
  }, []);

  const getData = (data: any) => {
    getExportTraining(data);
  };
  const getExportTraining = async (data: any) => {
    const userId: any = selector.user_id;
    const companyId: any = selector.company_id;
    const payload = {
      event: data?.event ? data?.event : "",
      user_id: userId,
      company_id: companyId,
      training_id: data?.training_id ? data?.training_id : "",
    };
    await trainingServices
      .exportAll(payload)
      .then((response: any) => {
        if (response.response == "success") {
          toast.success("Your request is queued");
        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.data);
      });
  };

  return (
    <>
      <ViewCompTrainingPresenter
        trans={t}
        i18n={i18n}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trainingEva={trainingEva}
        callBackGetData={getData}
        editTraineesData={editTraineesData}
      />
      <DTOViewCompletedTraining />
    </>
  );
};
export default ViewCompTrainingController;
